import React from "react";
import Terms from "./FormSteps/Terms";
import CommunicationStep from "./FormSteps/CommunicationStep";
import ProfessionalismStep from "./FormSteps/ProfessionalismStep";
import SupportStep from "./FormSteps/SupportStep";
import RecommendStep from "./FormSteps/RecommendStep";
import MessageStep from "./FormSteps/MessageStep";
import ThankYou from "./FormSteps/ThankYou";

const FormStep = ({
  termsAccepted,
  candidateName,
  employerName,
  recruiterName,
  agencyName,
  checkBoxOnChange,
  proceedToReview,
  step,
  setRating,
  communicationRating,
  professionalismRating,
  supportRating,
  recommendRating,
  reviewMessage,
  setReviewMessage,
  formLoading,
}) => {
  let currentStep;

  switch (step) {
    case 1:
      currentStep = (
        <CommunicationStep
          setRating={setRating}
          rating={communicationRating}
          recruiterName={recruiterName}
          agencyName={agencyName}
        />
      );
      break;
    case 2:
      currentStep = (
        <ProfessionalismStep
          setRating={setRating}
          rating={professionalismRating}
          recruiterName={recruiterName}
          agencyName={agencyName}
        />
      );
      break;
    case 3:
      currentStep = (
        <SupportStep
          setRating={setRating}
          rating={supportRating}
          recruiterName={recruiterName}
          agencyName={agencyName}
        />
      );
      break;
    case 4:
      currentStep = (
        <RecommendStep
          setRating={setRating}
          rating={recommendRating}
          recruiterName={recruiterName}
          agencyName={agencyName}
        />
      );
      break;
    case 5:
      currentStep = (
        <MessageStep
          step={step}
          recruiterName={recruiterName}
          agencyName={agencyName}
          reviewMessage={reviewMessage}
          setReviewMessage={setReviewMessage}
          formLoading={formLoading}
        />
      );
      break;
    case 6:
      currentStep = <ThankYou recruiterName={recruiterName} />;
      break;
    default:
      currentStep = (
        <Terms
          termsAccepted={termsAccepted}
          checkBoxOnChange={checkBoxOnChange}
          candidateName={candidateName}
          employerName={employerName}
          recruiterName={recruiterName}
          proceedToReview={proceedToReview}
        />
      );
      break;
  }
  return currentStep;
};

export default FormStep;
